import { render, staticRenderFns } from "./SelectClient.vue?vue&type=template&id=0444cd70&scoped=true&"
import script from "./SelectClient.vue?vue&type=script&lang=js&"
export * from "./SelectClient.vue?vue&type=script&lang=js&"
import style0 from "./SelectClient.vue?vue&type=style&index=0&id=0444cd70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444cd70",
  null
  
)

export default component.exports